import React from "react";
import CardSlide from "../Slider/card_slide";

export const SlideData = [
  {
    id: 1,
    name: "Baseline shorts",
    cate: "34,000 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FBaseline%20Shorts%20(1).jpg?alt=media&token=667ed023-9764-4314-923a-3d461bdd5e50",
  },
  {
    id: 2,
    name: "Dynamic Shorts",
    cate: "29,500 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FDynamic%20Shorts%20(1).png?alt=media&token=7a4a7fb3-d222-43b1-8f6b-64e6236c22a6",
  },
  {
    id: 3,
    name: "Flow Running Short",
    cate: "34,000 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FFlow%20Running%20Shorts%20(1).jpg?alt=media&token=47eb054a-d037-482f-a712-ad7df6c5aae5",
  },
  {
    id: 4,
    name: "Essential Shorts",
    cate: "29,500 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FEssential%20Shorts%20(1).jpg?alt=media&token=8e1370b3-3fea-4022-9f8c-d65ba2efd654",
  },
  {
    id: 5,
    name: "Kardio Shorts",
    cate: "34,000 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FAce%20Bra%20(1).png?alt=media&token=786a0c0f-312e-4a0e-b87d-2a3c3549d9a2",
  },
  // {
  //   id: 6,
  //   name: "something",
  //   cate: "recom",
  //   img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP01028.jpg?alt=media&token=cd63e31d-6c4f-4898-ba54-5170ffc8a36a",
  // },
];
const Short = ({title,subTitle}) => {
  return (
    <div>
      <div className="text-center mb-2 mt-10">
                 <h2 className="uppercase text-[13px] ">{title}</h2>
                 <h1 className="uppercase text-[22px]">{subTitle}</h1>
            </div>
      <CardSlide SlideData={SlideData} /> 
           <div className="text-center mt-8"><button className="bg-primary text-white  text-sm uppercase px-6 py-2 ">Shop now</button></div>
           <hr className="mt-10" />
    </div>
  );
};

export default Short;
